module.exports = __webpack_public_path__ + "img/sysco-logo.181a85d6.jpg";